@if (compareProduct) {
  @if (!comparePage) {
    <div class="compare-body">
      <div>
        <label>
          <input type="checkbox"
            [checked]="compare[productId]"
            (click)="addToCompare(productId)">
          @if (!compare[productId]) {
            <span class="text-nowrap" translate>Mark to Compare</span>
          } @else {
            <span translate>Selected</span>
          }
        </label>
        @if (compare[productId]) {
          <div [routerLink]="['/catalogue/compare-products']"
            class="compare-btn" translate>
            <i class="fa fa-clone"></i>
            <span class="link" translate>Compare Selected</span>
          </div>
        }
      </div>
    </div>
  } @else {
    <button
      (click)="removeFromCompare(productId)"
      [routerLink]="['/catalogue/compare-products']"
      class="remove-btn-compare btn align-self-end"
      title="{{'Remove From Compare'|translate}}">
      <i class="material-icons">close</i>
    </button>
  }
}
<ng-template #compareDialog>
  <div class="modal-header">
    <h5 translate>Compare Products</h5>
    <button mat-dialog-close="true" class="btn float-end close-dialog p-0">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
  <div class="modal-body">
    <span translate>can't compare more than 3 products</span>
    <div>
      <a  mat-dialog-close="true" [routerLink]="'/catalogue/compare-products'" translate>Link to compare</a>
    </div>
  </div>
</ng-template>
